export default __webpack_public_path__ + "static/media/apostar_icons_white_benutzer_datenaendern.e7431230.svg";